import { useResizeObserver as c } from "@placer-ui/hooks";
import { useState as N, useEffect as D } from "react";
import { HEADING_MARGIN as L, ICON_SIZE_WITH_PADDING as h, CHECKBOX_SIZE_WITH_PADDING as l, THUMBNAIL_SIZE_MEDIUM as S, THUMBNAIL_SIZE_SMALL as a } from "./index.es765.js";
const d = ({
  ThumbnailSrc: t,
  description: o,
  padding: e,
  spacingMapping: f,
  Icon: r,
  onSelection: n,
  zoomPercentage: _
}) => {
  const [R, i] = N(0), { containerRef: m, contentRect: I } = c(100), { containerRef: A, contentRect: E } = c(100);
  return D(() => {
    const s = I.width;
    if (s > 0) {
      const H = t ? o ? S : a : 0, u = typeof e == "number" ? e : parseInt(f[e] || "0"), M = s + u + (r ? h : 0) + H + (n ? l : 0);
      i(M - L);
    }
  }, [
    I,
    E,
    e,
    r,
    t,
    n,
    o,
    _,
    f
  ]), {
    moreInfoLeft: R,
    headingRef: m,
    titleHolderRef: A
  };
};
export {
  d as useAccordionItemMoreInfo
};
//# sourceMappingURL=index.es767.js.map
